$(document).ready(function(){
//  $(".memenu").memenu();

	// testimonial
  var swiper = new Swiper('.testimonial', {
    pagination: {
      el: '.swiper-pagination',
    },
    autoplay: $('.testimonial.swiper-container').data('autoplay'),
    speed: $('.testimonial.swiper-container').data('speed')
  });
  
  $('.thumbnail_inner').on('click', function(e){
    $('.img-border.active').removeClass('active')
    $(this).find('.img-border').addClass('active')
    var id = $(this).data('count');
    $('.product-image').each(function(e){
      var pro_id = $(this).data('count')
      if(pro_id == id){
        $(this).show()
      }else{
        $(this).hide()
      }
    })
  })
  
  $(".scroll").click(function(event){		
    event.preventDefault();
    $('html,body').animate({scrollTop:$(this.hash).offset().top},1000);
  });
  
  function myFunction() {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }
  shop_swiper();
  $('.ctm_Size .swatch-element').on('click',function(e){

   var isTrack = $("#inventory_management").val();
    
//    $(".ctm_Size .swatch-element").children().attr("checked",false);
    $(this).children().attr("checked",true);
    var pat = $(this).data("pattern");

    var selectValue = $(this).data("value");
    var selectedSize = selectValue;
    var selectedColor = $(".ctm_Color .swatch_active input[type=radio]").filter(":checked").val();

    if(pat==0)
      var selectPat= selectedSize+'/'+selectedColor;
    else
      var selectPat= selectedColor+'/'+selectedSize;

     $('#ProductSelect option').attr('selected',false);

    $('#ProductSelect option')
.filter(function() { return $.trim( $(this).text() ) == selectPat; }).attr('selected','selected');
    $('#ProductSelect').trigger("change");

    if(isTrack)
    {
        var hasValue =$('select#ProductSelect > [selected]').length;
     
    if(hasValue>0)
    {
      $(".product-form__cart-submit").attr("disabled",false);
      $(".product-form__cart-submit span").text("Add to cart");
      $(".buy-now span").text("Buy it now");
      $(".buy-now").attr("disabled",false);
      $(".product-form__cart-submit span").removeClass("white");

    }else

    {
      $(".product-form__cart-submit").attr("disabled",true);
      $(".buy-now").attr("disabled",true);
      $(".buy-now span").text("Sold Out");
      $(".product-form__cart-submit span").text("Sold Out");
      $(".product-form__cart-submit span").addClass("white");

    }
    }
    
    
    $('.ctm_Size .swatch-element').removeClass('swatch_active')
    $(this).addClass('swatch_active')
  })
  
  $('.ctm_Color .swatch-element').on('click',function(e){
       var isTrack = $("#inventory_management").val();

//     $(".ctm_Color .swatch-element").children().attr("checked",false);
    $(this).children().attr("checked",true);
    
    
    var pat = $(this).data("pattern");
    var selectValue = $(this).data("value");
    var selectedColor = selectValue;
    var selectedSize = $(".ctm_Size .swatch_active input[type=radio]").filter(":checked").val();
  
    if(pat==0)
      var selectPat= selectedColor+'/'+selectedSize;
    else
      var selectPat= selectedSize +'/'+selectedColor;
    
    
    
    
    $('#ProductSelect option').attr('selected',false);
    
    
    $('#ProductSelect option')
    .filter(function() { return $.trim( $(this).text() ) == selectPat; }).attr('selected','selected');
    $('#ProductSelect').trigger("change");
 if(isTrack)
    {
    var hasValue =$('select#ProductSelect > [selected]').length;
     
    if(hasValue>0)
    {
      $(".product-form__cart-submit").attr("disabled",false);
      $(".product-form__cart-submit span").text("Add to cart");
      $(".buy-now span").text("Buy it now");
      $(".buy-now").attr("disabled",false);
      $(".product-form__cart-submit span").removeClass("white");

    }else

    {
      $(".product-form__cart-submit").attr("disabled",true);
      $(".buy-now").attr("disabled",true);
      $(".buy-now span").text("Sold Out");
      $(".product-form__cart-submit span").text("Sold Out");
      $(".product-form__cart-submit span").addClass("white");

    }
    }
    $('.ctm_Color .swatch-element').removeClass('swatch_active')
    $(this).addClass('swatch_active');
    $(".current_color").html($(this).data('value'));
    
    
      var img_id = $(this).data('img-id');
    $('.product_thumbnails .thumbnail_inner').each(function(e){
      var id = $(this).data('img-id')
      if(id == img_id){
        $(this).trigger('click')
      }
    })
    
    
  })
  
  if($(window).width() < 992){
    $( ".sidebar_sub_div h3" ).click(function() {
      $(this).parent( ".sidebar_sub_div").find(".product-categories").slideToggle( "slow" );
      $(this).parent( ".sidebar_sub_div").find("h3").toggleClass('ctm_active');
    });
  }
  
  $(window).on('load',function(e) {
    var arrow_style = $('.homepage_slider').attr('data-arrow-style');
	var left,right;
    console.log('12364579845613246578912dmo',arrow_style)
    if(arrow_style == 'arrow_style_second'){
	  left = "//cdn.shopify.com/s/files/1/0560/9898/0016/t/2/assets/New_Project_4.png?v=168058898817716221241618191994";
      right = "//cdn.shopify.com/s/files/1/0560/9898/0016/t/2/assets/New_Project_5.png?v=25347446466785987641618191995";
      console.log('12364579845613246578912')
    }else{
      left = "//cdn.shopify.com/s/files/1/0560/9898/0016/t/2/assets/left_1.png?v=168058898817716221241618191990";
      right = "//cdn.shopify.com/s/files/1/0560/9898/0016/t/2/assets/left.png?v=25347446466785987641618191990";
    }
    $('.homepage_slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: $('.homepage_slider').data('autoplay'),
      autoplaySpeed: $('.homepage_slider').data('speed'),
      arrows: true,
      nextArrow: '<span class="slick-next"><img src='+left+'></span>',
      prevArrow: '<span class="slick-prev"><img src='+right+'></span>',
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  });
  
})

if($('.homepage_slider .slick-current .slide_description').hasClass('video_slide')){
  $('.homepage_slider .slick-current .video_slide').get(0).play()
}

$(window).on('load',function(e){
  $('.fa-chevron-left').click(function(){
    $(".homepage_slider").slick('slickPrev');
  });
  $('.fa-chevron-right').click(function(){
    $(".homepage_slider").slick('slickNext');
  });
  $('.homepage_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    console.log($(this).find('.slick-current .slide_description').hasClass('video_slide'))
    if($(this).find('.slick-current .slide_description').hasClass('video_slide')){    
      $(this).find('.slick-current .video_slide .videoPlayer').get(0).play()
      console.log('test')
    }else{
      console.log('test	123')
      $(this).find('.slick-slide').each(function(e){
        if($(this).find('.slide_description').hasClass('video_slide')){
          console.log('demo test	123')
          $(this).find('.video_slide .videoPlayer').get(0).pause()
        }
      })
    }
  });
})

$(window).resize(function(e){
	shop_swiper();
})
function shop_swiper(){
  var swiper = new Swiper('.shop-brand .swiper-container', {
    slidesPerView: 1,
    breakpoints: {
      640: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}


$(window).on('load',function(e){
// 	$('.ctm_zoom').zoom({ on:'click' });
  $('.ctm_zoom').zoom({ on:'click' });
  $('.product_thumbnails .thumbnail_inner').on('click',function(e){
    var cls = $(this).data('cls');
    setTimeout(function(e){
      $('.'+cls).find('[role="presentation"]').remove();
    },200)
    setTimeout(function(e){
      $('.'+cls).zoom({ on:'click' });
    },400)
  })
  

  
  if($.cookie("Newletter") == undefined){
    
    $.cookie("Newletter", "popenabled", { expires: 1 , path: '/' });
    
    $("#newsletter").modal({
      fadeDuration: 300
    });
  }
  
})